export default "__VITE_ASSET__d2255646__"